import React from 'react';
import { CanArgs, useCan } from './useCan';

type Props = React.PropsWithChildren<
  {
    else?: React.ReactNode;
  } & CanArgs
>;

const Can: React.FC<Props> = ({
  permission,
  resource,
  requiresAll = false,
  else: fallback,
  children,
}) => {
  const { can } = useCan();

  return can({ permission, resource, requiresAll }) ? (
    <>{children}</>
  ) : fallback ? (
    <>{fallback}</>
  ) : null;
};

export { Can };
